import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AiFollowupConfigService } from '../../../services/index';

@Component({
    selector: 'add-edit-ai-followup-config',
    templateUrl: './addEditAiFollowupConfig.component.html'
})
export class AddEditAiFollowupConfigComponent implements OnInit {
    public title: string;
    public configData: any = {};
    public dropdowns: any = { aiStatus: [], followupTypes: [], trackDays: [], followupTeams: [] };
    isLoading = false;
    trackDaySelections: any[] = [];

    @Output() loadEvent = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private aiFollowupConfigService: AiFollowupConfigService
    ) {}

    ngOnInit() {
        if (!this.configData.max_retry_count) { this.configData.max_retry_count = 0; }
        this.buildTrackDaySelections();
    }

    buildTrackDaySelections() {
        const count = parseInt(this.configData.max_retry_count, 10) || 0;
        const existing: any[] = this.configData.track_day_config || [];
        this.trackDaySelections = [];
        for (let i = 1; i <= count; i++) {
            const found = existing.find((t: any) => +t.track === i);
            this.trackDaySelections.push({ track: i, track_day_id: found ? found.track_day_id : '' });
        }
    }

    onRetryCountChange() {
        this.buildTrackDaySelections();
    }

    onSave() {
        const payload = Object.assign({}, this.configData);
        payload.track_day_config = JSON.stringify(this.trackDaySelections);
        this.isLoading = true;
        this.aiFollowupConfigService.save(payload).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');
                this.bsModalRef.hide();
                this.loadEvent.emit();
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiFollowupConfig/addEditAiFollowupConfig.component.ts